<ng-container *ngIf="antwoordResultaat">
  <div *ngIf="antwoorden && antwoorden.length == 1">
    <div data-hj-suppress>{{antwoorden[0].titel}}</div>
  </div>
  <ul *ngIf="antwoorden && antwoorden.length > 1">
    <li data-hj-suppress *ngFor="let antwoord of antwoorden">{{antwoord.titel}}</li>
  </ul>
</ng-container>